var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"section-message-fade"}},[(_vm.show)?_c('div',{class:['section-message', _vm.type ? `section-message-${_vm.type}` : '']},[_c('span',{staticClass:"section-message-con"},[_vm._v(_vm._s(_vm.text))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }